import React, { useState } from 'react';
import EventsCarousel from '../components/events/EventsCarousel';
import ProshowArtists from '../components/events/ProshowArtists';
import EventSchedule from '../components/events/EventSchedule';

const Events = () => {
  const [isScheduleVisible, setIsScheduleVisible] = useState(false);

  const toggleSchedule = () => {
    setIsScheduleVisible(true);
    // Smooth scroll to the schedule section after it's rendered
    setTimeout(() => {
      const element = document.getElementById('event-schedule');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  return (
    <div id="events">
      <EventsCarousel onImageClick={toggleSchedule} />
      {isScheduleVisible && <EventSchedule />}
      <ProshowArtists />
    </div>
  );
};

export default Events;